// Thin composer — wires Remy sub-hooks together.
// Consumers see the identical API as before.
import { Wine } from '@/types';
import { useToolHandler } from './remy/useToolHandler';
import { useRemyChat } from './remy/useRemyChat';
import { useRemyVoice } from './remy/useRemyVoice';

export const useGeminiLive = (localCellar: Wine[], cellarSnapshot: string) => {
  const tools = useToolHandler(localCellar);
  const chat = useRemyChat(cellarSnapshot, localCellar, {
    handleToolCalls: tools.handleToolCalls,
    stagedWineRef: tools.stagedWineRef,
  });
  const voice = useRemyVoice(chat.sendMessage);

  return {
    transcript: chat.transcript,
    isRecording: voice.isRecording,
    isProcessing: chat.isProcessing,
    stagedWine: tools.stagedWine,
    ingestionState: tools.ingestionState,
    startRecording: voice.startRecording,
    stopRecording: voice.stopRecording,
    sendMessage: chat.sendMessage,
  };
};
